import { ColumnDefinition } from '../../models/column';

export interface MonitorFilter {
  companyType: string;
  memberPriority: string;
  retailPriority: string;
}

export enum MonitorViewType {
  Overview = 'Overview',
  Retail = 'Retail',
  Priority = 'Priority'
}

export interface MonitorOverviewItem {
  id: string;
  maturity: Date;
  series: string;
  coupon: number;
  amount: number;
  total: number;
  balance: number;
  subscription: number;
  trancheId?: string;
}

export interface MonitorOverviewViewItem extends MonitorOverviewItem {
  formatted: {
    maturity: string;
    series: string;
    coupon: string;
    amount: string;
    total: string;
    balance: string;
    subscription: string;
  };
}

export type GridData = [
  ColumnDefinition[],
  MonitorOverviewViewItem[],
  MonitorOverviewViewItem
];
